import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import Layout from '@src/components/layout/Layout';
import { useCallback, useEffect, useState } from 'react';
import ProductionAdd from './components/ProductionAdd';
import useFindProductionsLazy from '@src/adapters/hooks/production/useFindProductions';
import ProductionDTO from '@src/adapters/dto/production/ProductionDTO';
import { useNavigate } from 'react-router-dom';
import { Routes } from '@src/navigation/Routes';
import ProductionCompany from '@src/components/productionCompany/ProductionCompany';

function Productions() {
  const [open, setOpen] = useState(false);
  const { execute: find } = useFindProductionsLazy();
  const [productions, setProductions] = useState<ProductionDTO[]>([]);
  const navigate = useNavigate();
  const findProductions = useCallback(() => {
    find().then((result) => {
      setProductions(result.productions);
    });
  }, [find]);

  useEffect(() => {
    findProductions();
  }, [findProductions]);

  const handleNewClick = () => {
    setOpen(true);
  };

  const handleClose = (production: ProductionDTO | undefined) => {
    if (production) {
      setProductions((prev) => [...prev, production]);
    }
    setOpen(false);
  };

  const handleRowClick = (
    event: React.MouseEvent<unknown>,
    production: ProductionDTO
  ) => {
    navigate(Routes.Jobs, { state: { productionId: production.id } });
  };

  return (
    <Layout>
      <Box
        sx={{
          padding: '0 20px 20px 20px',
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
        }}>
        <Typography variant="h4">Productions</Typography>
        <Button
          onClick={handleNewClick}
          color="secondary"
          variant="contained"
          size="medium">
          New Production
        </Button>
      </Box>
      <Paper elevation={8}>
        <TableContainer>
          <Table
            aria-labelledby="productions"
            size="small"
            aria-label="Productions table">
            <TableHead>
              <TableRow>
                <TableCell component="th" key="variant" align="left">
                  Production Name
                </TableCell>
                <TableCell component="th" key="lastName" align="left">
                  Production Company
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productions.map((production, index) => {
                return (
                  <TableRow
                    hover
                    onClick={(event) => handleRowClick(event, production)}
                    role="checkbox"
                    tabIndex={-1}
                    key={index}
                    sx={{ cursor: 'pointer' }}>
                    <TableCell scope="row">{production.name}</TableCell>
                    <TableCell scope="row">
                      <ProductionCompany id={production.productionCompanyId} />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={recordCount}
        rowsPerPage={rowsPerPage}
        page={selectedPage}
        onPageChange={(event, number) => changePage(number)}
        onRowsPerPageChange={(event) => {
          changeRowsPerPage(parseInt(event.target.value, 10));
          changePage(0);
        }}
      /> */}
      </Paper>
      <ProductionAdd open={open} close={handleClose} />
    </Layout>
  );
}

export default Productions;
